<template>
  <div class="block">
    <div class="flex items-center px-4 py-4 sm:px-6">
      <div @click="onChange" class="min-w-0 flex-1 flex items-center cursor-pointer">
        <div class="flex-shrink-0">
          <span class="inline-block overflow-hidden" :id="action.id">
            <div v-if="state" >
              <CheckIcon class="icon icon-done" aria-hidden="true" />
            </div>
            <div v-else="state">
              <PencilIcon class="icon icon-todo" aria-hidden="true" />
            </div>
          </span>
        </div>
        <div class="min-w-0 flex-1 px-4 md:grid md:grid-cols-1 md:gap-4">
          <div>
            <p class="text-sm font-medium text-gray-700">
              {{ action.description }}
            </p>
            <div v-if="action.has_link">
              <a :href="action.link_target" class="text-sm font-medium text-teal-600">
                {{ action.link_label }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import { useCreateResource } from '@/client/actions';
import client from '@/client/index';

const props = defineProps({action: Object});
const emits = defineEmits(['updated']);

const model = computed(() => props.action.id);
const state = computed(() => props.action.completed);
const target = computed(() => '/api/experiments/actions/' + model.value);

const { creating, create } = useCreateResource(target);

const onSuccess = () => emits('updated');
const onChange = () => create(onSuccess);
</script>

<style scoped>
.icon
{
  @apply h-8 w-8 rounded-full p-2;
  @apply flex items-center justify-center;
  @apply ring-8 ring-white;
  @apply text-white;
};

.icon-todo
{
  @apply bg-gray-400;
};

.icon-done
{
  @apply bg-teal-500;
};
</style>
